/**
 * @providesModule CatalogToolbar
 *
 */

import * as React from 'react'
import styled, { css } from 'styled-components'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router-dom'

import { InputGroup } from '@blueprintjs/core'

import { Consumer as ContentItemSelectionContextConsumer } from 'deployment/contentItemSelectionContext'
import Toolbar from 'utility/Toolbar'
import { getSearchPath } from 'catalog/search_results/SearchForm'
import TranslatedSpotlight from 'shared/spotlight/TranslatedSpotlight'
import { ReaderDataContext } from 'catalog/readerData'



const CatalogToolbar = ({ history }) => {
  const {
    roles: { author, instructor },
  } = React.useContext(ReaderDataContext)

  return (
    <ContentItemSelectionContextConsumer>
      {({ selecting }) => (
        <Toolbar
          groups={[
            [
              {
                message: 'catalog.catalog',
                icon: 'home',
                onClick: () => history.push('/'),
              },

              selecting || {
                message: author
                  ? 'myCases.index.myCases'
                  : 'cases.new.createACase',
                icon: 'annotation',
                onClick: () => (window.location = '/my_cases'),
                spotlightKey: 'my_cases',
              },

              selecting || {
                message: instructor
                  ? 'deployments.index.myDeployments'
                  : 'deployments.index.deployACase',
                icon: 'follower',
                onClick: () => (window.location = '/deployments'),
              },
            ],

            [],

            [{ component: <Search /> }],
          ]}
        />
      )}
    </ContentItemSelectionContextConsumer>
  )
}

export default withRouter(CatalogToolbar)

class SearchField extends React.Component {
  state = { active: false }
  input

  handleSubmit = (e) => {
    e.preventDefault()
    if (!this.input || this.input.value === '') return

    this.input &&
      this.props.history.push(
        getSearchPath({
          q: this.input.value,
        })
      )
    this.input && this.input.blur()
    this.input && (this.input.value = '')
  }

  render () {
    return (
      <TranslatedSpotlight spotlightKey="catalog_search">
        {({ ref }) => (
          <FormCoveringToolbarOnMobile
            active={this.state.active}
            onSubmit={this.handleSubmit}
            ref={ref}
          >

            <InputGroup
              inputRef={el => (this.input = el)}
              className="Toolbar__search pt-round bp4-round"
              leftIcon="search"
              aria-label={this.props.intl.formatMessage({
                id: 'search.searchCases',
              })}
              rightElement={
                <button
                  type="button"
                  aria-label={this.props.intl.formatMessage({
                    id: 'search.submitSearch',
                  })}
                  className="Toolbar__item Toolbar__search-action pt-button bp4-button pt-minimal bp4-minimal pt-icon-arrow-right bp4-icon-arrow-right"
                  onClick={this.handleSubmit}
                />
              }
              placeholder={this.props.intl.formatMessage({
                id: 'search.searchCases',
              })}
              onFocus={() => this.setState({ active: true })}
              onBlur={() => this.setState({ active: false })}
            />
          </FormCoveringToolbarOnMobile>
        )}
      </TranslatedSpotlight>
    )
  }
}

const Search = withRouter(injectIntl(SearchField))

const FormCoveringToolbarOnMobile = styled.form`
  @media screen and (max-width: 513px) {
    background-color: #1d3f5e;
    margin-left: -24px;
    ${({ active }) =>
      active
        ? css`
            margin-left: 0px;
            position: absolute;
            left: 14px;
            width: calc(100vw - 28px);
          `
        : ''};
  }
`
